import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Card, CardContent, TextField, Checkbox, FormControlLabel, Button, Stack } from '@mui/material';
import { Page, PageTitle } from '../../../components';
import useFetch from '../../../hooks/useFetch';

function AccountCard({ account, fetchResource, onSaved }) {
  const { t } = useTranslation();
  const [nickname, setNickname] = useState(account.nickname || '');
  const [entity, setEntity] = useState(account.entity || '');
  const [location, setLocation] = useState(account.location || '');
  const [active, setActive] = useState(Boolean(account.active));
  const [last4, setLast4] = useState(account.account_last4 || '');

  const save = async () => {
    const r = await fetchResource({
      resource: `calendar/bank-accounts/${account.id}/edit`,
      body: { nickname, entity, location, active, accountLast4: last4 || null },
    });
    if (!r.error) onSaved();
  };

  return (
    <Card sx={{ mb: 1 }}>
      <CardContent>
        <Stack spacing={1}>
          <TextField size='small' label={t('calendar.admin.nickname')} value={nickname} onChange={e => setNickname(e.target.value)} />
          <TextField size='small' label={t('calendar.admin.entity')} value={entity} onChange={e => setEntity(e.target.value)} />
          <TextField size='small' label={t('calendar.admin.location')} value={location} onChange={e => setLocation(e.target.value)} />
          <TextField size='small' label={t('calendar.admin.last4')} value={last4} onChange={e => setLast4(e.target.value)} />
          <FormControlLabel control={<Checkbox checked={active} onChange={e => setActive(e.target.checked)} />} label={t('calendar.admin.active')} />
          <Stack direction='row' spacing={1}>
            <Button onClick={save}>{t('calendar.review.save')}</Button>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default function BankAccounts({ auth, setAuth }) {
  const { t } = useTranslation();
  const { fetchResource, showAlert, alertMessage } = useFetch({ setAuth });
  const [accounts, setAccounts] = useState([]);
  const canManage = Boolean(auth.perms?.CAL_MANAGE);
  const load = () => fetchResource({ method: 'GET', resource: 'calendar/bank-accounts' }).then(r => !r.error && setAccounts(r.accounts || []));
  useEffect(() => { if (canManage) load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!canManage) return <Page><PageTitle>{t('calendar.admin.accounts')}</PageTitle></Page>;

  return (
    <Page>
      <PageTitle>{t('calendar.admin.accounts')}</PageTitle>
      {showAlert && <Alert severity={alertMessage.type} variant='filled'>{alertMessage.message}</Alert>}
      {accounts.map(a => <AccountCard key={a.id} account={a} fetchResource={fetchResource} onSaved={load} />)}
    </Page>
  );
}
